import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store/store";

export const alertNotificationsState = (state: RootState) => state.alertsNotifications.alerts;
export const alertsSelector = createSelector(alertNotificationsState, (alerts) => alerts);
